// Footer.js

import React from "react";
import "./Footer.scss";
import logo from "../../assets/images/logosvg.svg";
import { Link } from "react-router-dom";
import {
  TiSocialTwitter,
  TiSocialFacebook,
  TiSocialInstagram,
} from "react-icons/ti";
import { PiTiktokLogoDuotone } from "react-icons/pi";
import { FaSnapchatGhost } from "react-icons/fa";
const Footer = () => {
  return (
    <footer className="p-2  ">
      <div className="logo-footer drop-shadow-md py-4 ">
        <img src={logo} alt="logo" />
      </div>
      <div className="links-footer container mx-auto pr-14 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* First Column */}
        <div>
          <h3 className="text-lg font-semibold mb-4">معلومات الاتصال</h3>
          <ul>
            <li>27 شارع القسم، الرياض</li>
            <li>+99900000</li>
            <li>support@mohm.com</li>
            <li>ساعات العمل: 8 صباحًا - 5 مساءً</li>
            <li>الأحد - يوم عطلة نهاية الأسبوع</li>
          </ul>
        </div>

        {/* Second Column */}
        <div>
          <h3 className="text-lg font-semibold mb-4">روابط سريعة</h3>
          <ul className="w-[180px]">
            <Link to={"/"}>
              <li>الرئيسية</li>
            </Link>
            <Link to="/MedicalNetwork">
              <li>الشبكات الطبية</li>
            </Link>
            <Link to="/couponsoffers">
              <li>العروض والكوبونات</li>
            </Link>
            <Link to="/about">
              <li>من نحن</li>
            </Link>
            <Link to="/">
              <li>الأسئلة الشائعة</li>
            </Link>
            <Link to="/contact">
              <li>اتصل بنا</li>
            </Link>
          </ul>
        </div>

        {/* Third Column */}
        <div>
          <h3 className="text-lg font-semibold mb-4">نشرة الأخبار</h3>
          <form className="mb-4">
            <input
              type="email"
              placeholder="البريد الإلكتروني"
              className=" p-4 w-full drop-shadow-md send-mail  bg-white rounded-full"
            />
            <button
              type="submit"
              className=" subscription-btn text-white px-4 py-2 mt-2 rounded hover:bg-blue-600 transition"
            >
              اشتراك
            </button>
          </form>
          <div className="policy flex py-6">
            <input type="checkbox" name="policy" id="policy" />
            <p className="mr-2">
              أوافق على أن بياناتي المقدمة يتم جمعها وتخزينها.
            </p>
          </div>
          <div className="social flex space-x-4">
            <div className="  p-2 rounded-full text-white">
              <TiSocialFacebook />
            </div>
            <div className="  p-2 rounded-full text-white">
              <TiSocialTwitter />
            </div>
            <div className="  p-2 rounded-full text-white">
              <FaSnapchatGhost />
            </div>
            <div className="  p-2 rounded-full text-white">
              <TiSocialInstagram />
            </div>
            <div className="  p-2 rounded-full text-white">
              <PiTiktokLogoDuotone />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
